<template>
  <div>
    <app-loading v-if="isLoading"></app-loading>
    <main class="card-list main-top-space" v-else>
      <section class="retry-area" v-if="responseError">
        <h3 class="retry-area__ttl">通信に失敗しました</h3>
        <a href="javascript:void(0);" @click="getHistoryBooks" class="btn-retry btn-retry--short">リトライ</a>
      </section>
      <div v-else>
        <div class="no-history" v-if="books.length === 0">まだ購入した商品はありません。</div>
        <div class="history-card" v-for="(book, index) in books" v-else>
          <div class="history-card__inner">
            <div class="history-card__photo">
              <img :src="book.img_url" alt="">
            </div>
            <section class="history-card__body history-card-body">
              <h4 class="history-card__ttl">{{ book.name_book }}</h4>
              <p>購入価格：￥{{book.paid_price}}</p>
              <p class="history-card__date">購入日：{{book.purchase_date}}</p>
              <a href="javascript:void(0);" class="btn-square btn-square--short" v-if="book.cancel_available" @click="cancelPurchase(book.id_book)">購入をキャンセル</a>
            </section>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import TopInformation from '../common/TopInformation.vue';
  import Book from '../books/Book.vue';
  import { topInformation } from '../../constants';
  import Loading from '../common/Loading.vue';

  export default {
    title: '購入履歴 | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: '購入履歴',
    description: 'abceed の購入履歴はこちら',
    keywords: 'toeic,abceed,globee,購入履歴',
    headerType: 'historyBack',
    components: {
      appTopInformation: TopInformation,
      appBook: Book,
      appLoading: Loading
    },
    data() {
      return {
        topInformation,
        responseError: false
      }
    },
    created() {
      this.getHistoryBooks();
    },
    computed: {
      books() {
        return this.$store.getters.bookHistory;
      },
      isLoading() {
        return this.$store.getters.isLoading;
      }
    },
    methods: {
      getHistoryBooks() {
        this.$store.dispatch("changeLoadingCondition", true);
        this.$store.dispatch("getBookHistory")
          .then(data => {
            this.responseError = data === 'error';
            this.$store.dispatch("changeLoadingCondition", false);
          }).catch(() => {
            this.$store.dispatch("changeLoadingCondition", false);
          });
      },
      cancelPurchase(bookId) {
        if (!confirm('購入をキャンセルしてもよろしいですか？')) {
          return;
        }
        this.$store.dispatch("changeLoadingCondition", true);
        this.$store.dispatch("cancelHistoryPurchase", {
          id_book: bookId,
          response_type: 1
        })
        .then(data => {
          if (!data.message) {
            alert('購入をキャンセルしました。');
          } else {
            if (data.message === 'This product can not be canceled.') {
              alert('この商品はキャンセル可能期間を過ぎています。');
            } else {
              alert('キャンセルに失敗しました。');
            }
          }
          this.$store.dispatch("changeLoadingCondition", false);
        })
        .catch(() => {
          alert('キャンセルに失敗しました。');
          this.$store.dispatch("changeLoadingCondition", false);
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/bookList/History.vue